/* import __COLOCATED_TEMPLATE__ from './content-version-history.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import { ScheduledContentUpdateStatus } from 'embercom/services/scheduled-content-update-service';
import type ScheduledContentUpdate from 'embercom/models/content-service/scheduled-content-update';
import type ArticleContent from 'embercom/models/articles/article-content';

interface Args {
  currentVersionIndex: number;
  localeName: string;
  versions: any[];
  liveVersionId: number;
  onSelectVersion: (index: number) => void;
  onCancel: () => void;
  toggleDiff: () => void;
  showDiff: boolean;
  onMoreData: () => void;
  hasMoreData: boolean;
  article: ArticleContent;
  selectedVersion: any;
  closeSideDrawer: () => void;
  onVersionRestore: () => void;
}

export default class ContentVersionHistory extends Component<Args> {
  isVersionScheduled = (versionId: number): boolean => {
    let updates = this.args.article?.scheduledContentUpdates;

    if (!updates) {
      return false;
    }

    return updates
      .toArray()
      .some(
        (update: ScheduledContentUpdate) =>
          update.status === ScheduledContentUpdateStatus.PENDING &&
          Number(update.entityVersionId) === Number(versionId),
      );
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Articles::Show::Content::ContentVersionHistory': typeof ContentVersionHistory;
    'articles/show/content/content-version-history': typeof ContentVersionHistory;
  }
}
